import React from 'react'
import { useIntl } from 'react-intl'
import { useHistory, useLocation } from 'react-router'
import { csx } from '@vtex/admin-ui'
import { useFragment } from 'react-relay-offline'

import {
  ProductDetailsSection,
  ProductDetailsSectionItem,
  productFragment,
} from '..'
import type { ProductDetailsDrawer_Product$key } from './__generated__/ProductDetailsDrawer_Product.graphql'

type ProductDetailsSectionContentProps = {
  productDescription: ProductDetailsDrawer_Product$key
}

export const ProductDetailsSectionContent = ({
  productDescription,
}: ProductDetailsSectionContentProps) => {
  const { formatMessage } = useIntl()
  const history = useHistory()
  const location = useLocation()
  const data = useFragment(productFragment, productDescription)

  if (data.description === '') {
    return null
  }

  const handleOpen = () => {
    const { pathname, search } = location

    history.push(`${pathname}${search}#/product-details-drawer`)
  }

  return (
    <ProductDetailsSection
      className={csx({ marginTop: '$space-8' })}
      productDescription={productDescription}
    >
      <ProductDetailsSectionItem
        onClick={handleOpen}
        title={formatMessage({ id: 'productDetailsDrawerTitle' })}
      />
    </ProductDetailsSection>
  )
}
